import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconInformation16pxBoldLightS = function IconInformation16pxBoldLightS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 16 16",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M1 8c0 3.86 3.141 7 7 7s7-3.141 7-7c0-3.86-3.141-7-7-7a7.009 7.009 0 00-7 7z",
      fill: "#E4E7ED"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 6a1 1 0 100-2 1 1 0 000 2zm1.254 5.99a.3.3 0 00.3-.3v-.35a.283.283 0 00-.213-.277c-.284-.085-.532-.16-.532-.48V7.3a.3.3 0 00-.3-.3H6.875a.3.3 0 00-.3.3v.236c0 .125.078.237.197.277.29.099.548.2.548.525v2.245c0 .318-.246.392-.53.477a.283.283 0 00-.216.279l.001.351a.3.3 0 00.3.3h2.379z",
      fill: "#788194"
    })]
  }));
};
export default IconInformation16pxBoldLightS;